import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'
import type { IntegrationSummary, IntegrationsResponse } from '../types/index'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string) {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

async function apiFetch<T>(method: string, path: string): Promise<T> {
  const token = Cookies.get('token')
  const headers: Record<string, string> = {}
  if (token) headers.Authorization = `Bearer ${token}`
  const res = await fetch(buildUrl(path), { method, headers })
  if (!res.ok) {
    if (res.status === 401 && token) {
      handleSessionExpired()
      throw new Error('Session expired')
    }
    const payload = await res.json().catch(() => null)
    const details = Array.isArray(payload?.error?.details) ? payload.error.details : null
    const detailMessage = details?.length
      ? details.map((d: { field?: string; message?: string }) => d.message || d.field).join('; ')
      : null
    throw new Error(detailMessage || payload?.error?.message || payload?.message || res.statusText || 'Request failed')
  }
  return res.json()
}

export async function getIntegrations(workspaceId: string): Promise<IntegrationSummary[]> {
  const data = await apiFetch<IntegrationsResponse>('GET', `/api/workspaces/${workspaceId}/integrations`)
  return data.integrations
}
